import { ActiveClaList } from '@models';

export interface ActiveClaListResult {
  activeClaList: ActiveClaList[];
}
